module.exports = __webpack_public_path__ + "img/中国工商银行_logo.686f4740.png";